import React, { useRef, useState } from "react";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import Modal from "../../../generic/Modal.jsx";
import Loader from "../../Loader/Loader.jsx";
import EmptyBox from "../../EmptyBox/EmptyBox.jsx";
import { FaRegFilePdf } from "react-icons/fa";
import { AiOutlineHistory } from "react-icons/ai";

export default function AmountCom({ ID }) {
  const [skip, setOpen] = useState(true);
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [editedData, setEditedData] = useState([]);
  const contentRef = useRef(null);
  const onClose = () => {
    setOpen(!skip);
  };

  const Open = async () => {
    setOpen(!skip);
    const response = await fetch(
      `https://alcrm.pythonanywhere.com/list/payment/${ID}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      }
    );
    const data = await response.json();
    setIsLoading(false);
    setData(data);
    setEditedData(data?.map((item) => ({ ...item, isEditing: false })));
  };

  const generatePDF = () => {
    const content = contentRef.current;

    html2canvas(content).then((canvas) => {
      const imgData = canvas.toDataURL("image/jpeg");
      const pdf = new jsPDF("p", "mm", "a4");

      const imgWidth = 170;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      pdf.addImage(imgData, "JPEG", 20, 20, imgWidth, imgHeight); 
      pdf.save("generated_pdf.pdf"); 
    });
  };

  return (
    <div>
      <button
        onClick={() => Open()}
        type="button"
        className="inline-flex gap-2 items-center rounded-md bg-blue-500 px-3 py-2 text-sm font-semibold text-white shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-blue-400"
      >
        <AiOutlineHistory />
        To'lov
      </button>
      {!skip && (
        <Modal closeModal={onClose} actionType="view">
          <div className="w-[90vw] h-[80vh] p-4">
            <div className="flex justify-between gap-x-6 px-2 py-3 items-center"></div>
            <ul className="  divide-y-reverse overflow-y-scroll h-[68vh] divide-gray-100 border rounded-lg col-span-12">
              {isLoading ? (
                <Loader
                  extraClass="col-span-12 flex justify-center"
                  Color="#62B238"
                />
              ) : editedData.length > 0 ? (
                editedData.map((val, index) => {
                  const isEditing = val.isEditing;
                  return (
                    <li
                      key={index}
                      className="pdff flex justify-between gap-x-6 px-2 py-3 cursor-pointer hover-bg-gray-200"
                    >
                      <div>
                        <p>{index + 1}</p>
                      </div>
                      <div
                        className="flex items-center justify-between w-1/2"
                        ref={contentRef}
                      >
                        <div className="min-w-0 flex gap-2">
                          <p className="text-sm font-semibold leading-6 text-gray-900">
                            {val.created_date}
                          </p>
                        </div>
                        <div className="min-w-0 flex gap-2">
                          <p className="text-sm font-semibold leading-6 text-gray-900">
                            {isEditing ? (
                              <input
                                className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                type="text"
                                value={val.price}
                                onChange={(e) =>
                                  setEditedData((prevData) =>
                                    prevData.map((item) =>
                                      item.id === val.id
                                        ? { ...item, price: e.target.value }
                                        : item
                                    )
                                  )
                                }
                              />
                            ) : (
                              <span className="text-base">
                                {" "}
                                To'lovi: {val.amount}
                              </span>
                            )}
                          </p>
                        </div>
                      </div>
                      <div>
                        <button
                          type="button"
                          className="inline-flex items-center rounded-md bg-blue-500 px-3 py-2 text-sm font-semibold text-white shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-blue-400"
                          onClick={() => generatePDF(val)}
                        >
                          <FaRegFilePdf
                            className="-ml-0.5 mr-1.5 h-5 w-5"
                            aria-hidden="true"
                          />
                          Check
                        </button>
                      </div>
                    </li>
                  );
                })
              ) : (
                <EmptyBox />
              )}
            </ul>
          </div>
        </Modal>
      )}
    </div>
  );
}
